const { getStock } = require('@balibart/stocks')

const logger = process.env.TEST ? console : {
  log: () => {},
}

// Work In Progress
const formatData = data => ({
  ...data,
  products: data.products || data.content,
  address: data.client ? data.client.address : data.address,
})


const getDeliveryImpact = (product, bp) => {
  try {
    const keys = Object.keys(product.variations)
    return keys.map((k) => {
      const variation = bp.variations.find(va => va.type === k &&
      va.reference === product.variations[k].reference) || {}
      return variation.deliveryImpact || 0
    })
  } catch (e) {
    logger.log({ message: 'grtDeliveryImpact', level: 'debug', e })
    return 0
  }
}

const getDelays = (product, baseProduct, price) => {
  try {
    const deliveryImpact = getDeliveryImpact(product, baseProduct)
    const { productionDelay = 4 } = baseProduct
    const { stockImpact } = getStock(product, product.variations) || {}
    const { delays } = price
    const variationImpact = typeof stockImpact === 'number' ? stockImpact : deliveryImpact
    const result = {
      deliveryMin: parseFloat(delays.deliveryMin) +
      parseFloat(productionDelay) + parseFloat(variationImpact),
      deliveryMax: parseFloat(delays.deliveryMax) +
      parseFloat(productionDelay) +
      parseFloat(variationImpact),
    }
    return result
  } catch (e) {
    logger.log({
      message: 'getDelays', step: 'catch', level: 'debug', e,
    })
    return {
      deliveryMin: 5,
      deliveryMax: 7,
    }
  }
}


module.exports = {
  formatData, getDeliveryImpact, getDelays,
}
